import * as React from "react";

export const ChevronRightIcon: React.FC<{
  className?: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  strokeWidth?: number | string;
}> = ({ className, size = 16, color = "currentColor", style, strokeWidth = "2" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    style={style}
  >
    <path
      d="M6 12l4-4-4-4"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);